import React from "react";
import { useDropdownDataContext } from "../Dropdown";

interface DropdownMenuItemProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

const DropdownMenuItem = ({ children, disabled = false, onClick = () => {} }: DropdownMenuItemProps) => {
  const { handleCloseMenu } = useDropdownDataContext();

  const handleClick = () => {
    onClick();
    handleCloseMenu();
  };

  return (
    <button type="button" className="dropdown-menu-item" onClick={handleClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default DropdownMenuItem;
